import { render } from "./our_team.vue?vue&type=template&id=1aa0634a"
import script from "./our_team.vue?vue&type=script&lang=js"
export * from "./our_team.vue?vue&type=script&lang=js"

import "./our_team.vue?vue&type=style&index=0&id=1aa0634a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__